// extracted by mini-css-extract-plugin
module.exports =  {"card":"card__7J491","hasShadow":"hasShadow__VHz8u","hasPadding":"hasPadding__alPXv"};